<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <div class="d-flex">
        <em>
          <br><strong>Enquête de la DREAL Grand Est </strong>
          <br><strong>concernant le ressenti par les habitants de VARANGEVILLE des tirs de mines </strong>
          <br><strong>ainsi que des vibrations accompagnant ces tirs.</strong>
          <br>
          <br>Madame, Monsieur,
          <br>
          <br>Les services de l'Etat engagent une enquête concernant l'objet ci-dessus.
          <br>Pour cela ils nous demandent de les informer sur deux points :
          <br>
          <br>
          <ul>
            <li>Le premier concerne les dates de bruits impulsionnels et de vibrations plus puissantes que d'habitude.</li>
            <li>Le deuxième concerne les lieux ou les moments où la perception des tirs est plus intense.</li>
          </ul>
          <br>Aussi, je vous demande de bien vouloir signaler via <a href="/#/recenser-tir"> notre site </a>ou par mail à <a href="mailto:a.selidaire@orange.fr">a.selidaire@orange.fr</a>,
          <br>lorsqu'il vous paraît que les tirs sont plus forts ou plus intenses
          <br>en précisant le lieu, le jour et l'heure où vous avez fait ce constat.
          <br>
          <br>Il est très important de participer à cette enquête,
          <br>pour une fois que l'administration nous demande notre avis.
          <br>
          <br>Nous devons jouer le jeu et je vous demande donc de partager cette enquête
          <br>via les réseaux sociaux ou tout autre moyen à votre convenance
          <br>avec le plus de personnes possibles.
        </em>
      </div>
    </v-slide-y-transition>
  </v-container>
</template>
